/**
 * Created by jpilz on 2/13/17.
 */
"use strict";
import {context} from '../../../objects/context.js';
import ko from 'knockout';
import customUtil from '../../../objects/customUtil.js';

class customOptionsReportModel {

    constructor(params) {
        // Profile
        this.componentName = "customOptionsReportModel";
        this.context = context;
        this.id = this.context.util.guid();
        this.visible = ko.observable(true);

        this.columnid = params.columnid;
        this.componentMessage = params.componentMessage;

        this.customUtilObj = new customUtil(this.context);

        this.title = ko.observable();

        this.dataArray = ko.observableArray([]);

        this.componentMessage.subscribe( () => {
            this.getData();
        });

        this.context.customHeaderTitles.subscribe( () => {
            this.updateHeader();
            //this.getData();
        });

        this.context.eventManager.subscribe((navObj) =>{
            this.handleNavChanged(navObj);
        },this, "navChanged");

        this.init();
        
    }

    init() {

        //this.getData();

    }

    handleNavChanged(navObj) {

        if(navObj == 'home')
        {
            this.updateHeader();
        }
    }

    reset() {



    }

    updateHeader() {

        console.log("customReport:updateHeader:");

        switch(this.columnid)
        {
            case 1:
                this.title(this.context.customHeaderTitles().optioncolumn1title);
                break;

            case 2:
                this.title(this.context.customHeaderTitles().optioncolumn2title);
                break;

            case 3:
                this.title(this.context.customHeaderTitles().optioncolumn3title);
                break;

            case 4:
                this.title(this.context.customHeaderTitles().optioncolumn4title);
                break;

            case 5:
                this.title(this.context.customHeaderTitles().optioncolumn5title);
                break;

            case 6:
                this.title(this.context.customHeaderTitles().optioncolumn6title);
                break;
            
        }

    }
        
    getData() {
        console.log("customReport:getData");

        this.customUtilObj.report(this.columnid).then( data => { 
            this.dataArray(data);
            console.log("dataArray: %o", this.dataArray());
        });

    }

}

export default { viewModel: customOptionsReportModel, template: require('!raw-loader!./customReport.html') };


// WEBPACK FOOTER //
// ./src/components/options/customReport/customReport.js